import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import api from "../lib/api";
import { logError } from "../lib/logger";

const priceDecimals = (abs) => {
  if (abs >= 1000) return 2;
  if (abs >= 1) return 3;
  return 5;
};

const fmtPrice = (p) => {
  if (p == null) return "—";
  const abs = Math.abs(p);
  const decimals = priceDecimals(abs);
  return p.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: decimals });
};

const changeColor = (pc, up) => {
  if (pc == null) return "text-zinc-500";
  return up ? "text-emerald-400" : "text-red-400";
};

const TickerItem = ({ q }) => {
  const pc = q.percent_change;
  const up = pc != null && pc >= 0;
  const color = changeColor(pc, up);
  const Arrow = up ? TrendingUp : TrendingDown;
  return (
    <div className="flex items-center gap-2 px-5 shrink-0" data-testid={`ticker-${q.epic}`}>
      <span className="text-zinc-400 text-sm font-medium">{q.label}</span>
      <span className="text-white text-sm font-mono font-semibold">{fmtPrice(q.price)}</span>
      {pc != null && (
        <span className={`flex items-center gap-0.5 text-xs font-mono ${color}`}>
          <Arrow size={12} /> {up ? "+" : ""}{pc}%
        </span>
      )}
      <span className="text-white/10 pl-3">|</span>
    </div>
  );
};

export default function MarketTicker() {
  const [quotes, setQuotes] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/ticker");
        if (alive) setQuotes(data.filter((q) => q.price != null));
      } catch (e) { logError("ticker", e); }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (quotes.length === 0) return null;
  const loop = [...quotes, ...quotes];

  return (
    <div className="w-full bg-[#0d0d0d] border-b border-white/10 overflow-hidden" data-testid="market-ticker">
      <div className="ticker-track flex whitespace-nowrap py-2.5">
        <div className="flex animate-ticker items-center">
          {loop.map((q, i) => <TickerItem key={`${q.epic}-${i}`} q={q} />)}
        </div>
      </div>
    </div>
  );
}
